import { render, staticRenderFns } from "./helpdeskModal.vue?vue&type=template&id=46e7e2d3&scoped=true"
import script from "./helpdeskModal.vue?vue&type=script&lang=js"
export * from "./helpdeskModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e7e2d3",
  null
  
)

export default component.exports